module.exports = __webpack_public_path__ + "static/media/lanna.31e79ad4.jpeg";